import React, { useState } from 'react';
import { post } from '../utils/api';

// FRONT DESK INVENTORY RELEASE REQUEST
export default function InventoryReleaseRequestPanel({
  delivery,
  user,
  onRefresh
}) {
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);

  const canRequest = [
    'super_admin',
    'front_desk_officer',
    'procurement_logistics_officer'
  ].includes(user?.role);

  if (!canRequest || !delivery) {
    return null;
  }

  const alreadyRequested =
    Boolean(delivery.inventory_release_requested_at);

  const released =
    Boolean(delivery.inventory_release_released_at) ||
    ['requested', 'accepted'].includes(
      delivery.handover_status
    );

  const availabilityConfirmed =
    delivery.customer_availability_status ===
      'confirmed';

  const requestRelease = async () => {
    if (
      !window.confirm(
        'Send this finished-goods release request to Inventory?'
      )
    ) {
      return;
    }

    setBusy(true);

    try {
      const response = await post(
        '/deliveries/' +
          delivery.id +
          '/inventory-release/request',
        {
          request_notes: notes.trim()
        }
      );

      alert(
        response.message ||
        'Release request sent to Inventory.'
      );

      setNotes('');

      if (onRefresh) {
        await onRefresh();
      }
    } catch (error) {
      alert(
        error.message ||
        'Inventory release could not be requested.'
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        background:'#fff',
        border:'1px solid #D8CFBF',
        borderRadius:12,
        padding:16,
        marginBottom:16
      }}
    >
      <div
        style={{
          fontSize:12,
          fontWeight:800,
          color:'#3B2A21',
          marginBottom:8
        }}
      >
        Finished Goods Release
      </div>

      {released ? (
        <div
          style={{
            background:'#E8F5EB',
            color:'#2E6B3A',
            border:'1px solid #B9DEC1',
            borderRadius:8,
            padding:12,
            fontSize:13
          }}
        >
          Inventory has released this package. Progress
          must accept physical custody with his own staff
          PIN before dispatch.
        </div>
      ) : alreadyRequested ? (
        <div
          style={{
            background:'#E7F5FF',
            color:'#3B5BDB',
            border:'1px solid #B9D7F5',
            borderRadius:8,
            padding:12,
            fontSize:13
          }}
        >
          Release has been requested. The package is
          waiting in Winner's Finished Goods Release
          Queue.
        </div>
      ) : !availabilityConfirmed ? (
        <div
          style={{
            background:'#FFF3DC',
            color:'#8B5E0A',
            border:'1px solid #F0D9A0',
            borderRadius:8,
            padding:12,
            fontSize:13
          }}
        >
          Confirm the customer's availability before
          requesting release from Inventory.
        </div>
      ) : (
        <>
          <p
            style={{
              fontSize:13,
              lineHeight:1.6,
              color:'#5F5147',
              margin:'0 0 12px'
            }}
          >
            Request Winner to verify and release the
            finished goods to the Delivery Desk. Payment
            will be checked again before the request is
            accepted.
          </p>

          <div className="form-group">
            <label className="form-label">
              Release Instructions or Notes
            </label>

            <textarea
              className="form-control"
              rows={2}
              value={notes}
              onChange={event =>
                setNotes(event.target.value)
              }
              placeholder="Optional package or handover instructions"
            />
          </div>

          <button
            type="button"
            className="btn btn-primary"
            onClick={requestRelease}
            disabled={busy}
          >
            {busy
              ? 'Sending Request...'
              : 'Request Release from Inventory'}
          </button>
        </>
      )}
    </div>
  );
}
